<template>
<div id="app">
    <v-card color="grey lighten-5" flat>
        <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>Destek Talepleri</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn class="white--text" flat @click="telefonAc()">
                    <span class="hidden-sm-and-down">Telefon Girişi</span>
                    <v-icon right dark>phone_callback</v-icon>
                </v-btn>
            </v-toolbar>
        </v-flex>
    </v-card>
    <v-container fluid="">
        <v-layout row wrap>
            <v-flex xs12 sm12 md4>
                <v-layout row wrap align-center="" justify-center="" fill-height="">
                    <v-layout row wrap align-center="" justify-center="">
                        <v-flex xs12 sm12 md12>
                            <v-form ref="musteriaraform" lazy-validation>
                                <v-layout row wrap>
                                    <v-flex xs12 sm10 md9>
                                        <v-autocomplete hide-details="" :items="musteriitems" v-model="SorunKayit.MusteriBilgi.MusteriID" item-text="Title" item-value="MusteriID" clearable label="Müşteri Ara"></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm1 md2>
                                        <v-btn @click="musteriBilgi()" @click.native="visible=!visible" color="info" fab small="" dark>
                                            <v-icon>add</v-icon>
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm1 md1>
                                        <v-btn small="" color="info" @click="filtrele()" fab dark>
                                            <v-icon>filter_list</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-flex>
            <v-flex ma-5 md3>
            </v-flex>
            <v-flex xs12 sm12 md4>
                <v-card color="info">
                    <v-layout>
                        <v-flex xs2 sm2 md2>
                            <v-layout align-center="" justify-center="" fill-height="">
                                <v-icon color="white" large="">person</v-icon>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                            <v-card-title primary-title="">
                                <v-flex xs12 sm12 md12>
                                    <v-layout>
                                        <v-flex xs12 sm6 md3>
                                            <v-list-tile-content>
                                                <span class="subheading font-weight-bold white--text">
                                                    Bekleyen Sorunlarınız
                                                </span>
                                            </v-list-tile-content>
                                        </v-flex>
                                        <v-flex xs12 sm6 md3>
                                            <v-list-tile-action>
                                                <v-btn class="font-weight-bold subheading  white--text  mb-1" @click="BekleyenSorunlar()" fab small color="error">{{bekleyenitems.length}}</v-btn>
                                            </v-list-tile-action>
                                        </v-flex>
                                        <v-flex xs12 sm6 md3>
                                            <v-list-tile-content>
                                                <span class="subheading font-weight-bold white--text">
                                                    Telefon Bekliyor
                                                </span>
                                            </v-list-tile-content>
                                        </v-flex>
                                        <v-flex xs12 sm6 md3>
                                            <v-list-tile-action>
                                                <v-btn class="font-weight-bold subheading  white--text  mb-1" @click="telefonBekliyorCek()" fab small color="error">{{telefonitems.length}}</v-btn>
                                            </v-list-tile-action>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-card-title>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
    <v-layout row wrap>
        <v-flex xs12 sm12 md12>
            <v-layout row="" wrap>
                <v-flex xs12 sm12 md6>
                    <v-toolbar color="blue" dark>
                        <v-toolbar-title>Sorunlar</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card>
                        <v-flex pa-2 xs12 sm12 md12>
                            <v-list two-line>
                                <template v-for="(item,index) in sorunitems">
                                    <v-hover v-bind:key="index" v-slot:default="{ hover }">
                                        <v-card :elevation="hover ? 12 : 1">
                                            <v-layout ma-2 row wrap>
                                                <v-flex xs6 sm4 md4>
                                                    <v-layout align-start="" justify-start fill-height>
                                                        <v-card flat="">
                                                            <v-list-tile>
                                                                <v-list-tile-content style="'overflow=inherit';">
                                                                    <v-list-tile-sub-title>
                                                                        <div class="font-weight-bold caption ">
                                                                            Ticket No:{{item.SorunID}}
                                                                        </div>
                                                                    </v-list-tile-sub-title>
                                                                    <v-list-tile-sub-title>
                                                                        <div v-html="'Müşteri Adı :'  + item.MusteriBilgi.MusteriAdi.substring(0,70)" class="font-weight-bold  caption">
                                                                        </div>
                                                                    </v-list-tile-sub-title>
                                                                    <v-list-tile-sub-title>
                                                                        <div class="font-weight-bold  caption">
                                                                            Arayan:{{item.Arayan}}
                                                                        </div>
                                                                    </v-list-tile-sub-title>
                                                                </v-list-tile-content>
                                                            </v-list-tile>
                                                        </v-card>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs6 sm3 md3>
                                                    <v-layout align-start="" justify-start fill-height>
                                                        <v-card flat="">
                                                            <v-list-tile>
                                                                <v-list-tile-content style="'overflow=inherit';">
                                                                    <v-list-tile-sub-title>
                                                                        <div class="font-weight-bold caption ">
                                                                            Alış Tarihi:{{item.AlisTarihi | dateformat}}
                                                                        </div>
                                                                    </v-list-tile-sub-title>
                                                                    <v-list-tile-sub-title>
                                                                        <div class="font-weight-bold  caption">
                                                                            Çözecek:{{item.CozecekBilgi.AdSoyad}}
                                                                        </div>
                                                                    </v-list-tile-sub-title>
                                                                    <v-list-tile-sub-title>
                                                                        <div v-html="'Sorun Tip:' + item.SorunTip.Aciklama.substring(0,20)" class="font-weight-bold  caption">
                                                                        </div>
                                                                    </v-list-tile-sub-title>
                                                                </v-list-tile-content>
                                                            </v-list-tile>
                                                        </v-card>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs10 sm8 md4>
                                                    <v-layout align-start="" justify-start fill-height>
                                                        <v-card flat="">
                                                            <v-list-tile>
                                                                <v-list-tile-content style="'overflow=inherit';">
                                                                    <v-list-tile-sub-title>
                                                                        <v-layout>
                                                                            <div v-html="'Sorun:' + item.SorunAciklama.substring(0,40)" class="font-weight-bold caption">
                                                                            </div>
                                                                        </v-layout>
                                                                    </v-list-tile-sub-title>
                                                                </v-list-tile-content>
                                                            </v-list-tile>
                                                        </v-card>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs2 sm4 md1>
                                                    <v-layout align-end="" justify-center="" fill-height="">

                                                        <v-card v-if="deneme!=sorunitems[index].SorunID" flat="">
                                                            <v-list-tile>
                                                                <v-list-tile-content>
                                                                    <v-layout>
                                                                        <v-flex v-if="secilen==true" xs12 sm4 md5>
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on }">
                                                                                    <v-btn large icon v-on="on">
                                                                                        <v-icon color="info">arrow_forward_ios</v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>Seçili Sorun</span>
                                                                            </v-tooltip>
                                                                        </v-flex>
                                                                        <v-flex v-if="secilen==false" xs12 sm4 md5>
                                                                            <v-layout>
                                                                                <v-tooltip bottom>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn small icon v-on="on" @click="SorunDuzenle(item.SorunID,item.MusteriBilgi.MusteriID)" @click.native="visible=!visible" class="mx-0">
                                                                                            <v-icon color="info">edit</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Sorun Düzenle</span>
                                                                                </v-tooltip>
                                                                                <v-tooltip bottom>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn small icon v-on="on" class="mx-0" @click.native="visibledestekliste=!visibledestekliste" @click="DestekListele(item.SorunID,item.MusteriBilgi.MusteriID)">
                                                                                            <v-icon color="purple">filter_list</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Destek Listele</span>
                                                                                </v-tooltip>
                                                                            </v-layout>
                                                                            <v-layout>
                                                                                <v-tooltip bottom>
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn small icon v-on="on" class="mx-0" @click="DestekIDSave(item.SorunID,item.MusteriBilgi.MusteriID)" @click.native="visibledestek=!visibledestek">
                                                                                            <v-icon color="green">add_box</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <span>Destek Ekle</span>
                                                                                </v-tooltip>
                                                                            </v-layout>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-list-tile-content>
                                                            </v-list-tile>
                                                        </v-card>
                                                        <v-card color="grey lighten-2" v-if="deneme==sorunitems[index].SorunID" flat="">
                                                            <v-list-tile>
                                                                <v-list-tile-content>
                                                                    <v-layout>
                                                                        <v-flex xs12 sm4 md5>
                                                                            <v-tooltip bottom>
                                                                                <template v-slot:activator="{ on }">
                                                                                    <v-btn large icon v-on="on">
                                                                                        <v-icon color="info">arrow_forward_ios</v-icon>
                                                                                    </v-btn>
                                                                                </template>
                                                                                <span>Seçili Sorun</span>
                                                                            </v-tooltip>
                                                                        </v-flex>
                                                                        <v-flex v-if="secilen==false" xs12 sm4 md5>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-list-tile-content>
                                                            </v-list-tile>
                                                        </v-card>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                            <v-spacer></v-spacer>
                                        </v-card>
                                    </v-hover>
                                </template>
                                <v-layout justify-center="">
                                    <template v-if="vmodelpagination">
                                        <div class="text-xs-center">
                                            <v-container>
                                                <v-layout justify-center>
                                                    <v-flex xs8>
                                                        <v-pagination v-model="sayfalama" :length="pagenumber"></v-pagination>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </div>
                                    </template>
                                </v-layout>
                            </v-list>
                        </v-flex>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm12 md6>
                    <v-layout v-if="baslikDestek =='Sorun Detay'" row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-toolbar color="#FFC107" dark>
                                <v-toolbar-title>{{baslikDestek}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-menu bottom left>
                                    <v-form ref="formaktarim" id="formaktarim" method="post" v-model="valid" lazy-validation>
                                        <input hidden type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" />
                                    </v-form>
                                    <template v-slot:activator="{ on }">
                                        <v-btn @click="DestekIDSave(SorunDetay.SorunID,SorunDetay.MusteriBilgi.MusteriID)" @click.native="visibledestek=!visibledestek" fab color="green" dark icon v-on="on">
                                            <v-icon>add</v-icon>
                                        </v-btn>
                                        <v-btn @click="addFiles()" fab color="green" dark icon>
                                            <v-icon>cloud_upload</v-icon>
                                        </v-btn>
                                        <div v-show="load2">
                                            <v-btn small="" fab ref="fab" @click="btnSubmitFiles()" color="green" dark>
                                                <v-icon>save</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                </v-menu>
                            </v-toolbar>
                            <v-expansion-panel>
                                <v-expansion-panel-content :value="visibledestekliste">
                                    <v-layout row wrap>
                                        <v-flex pa-1 xs12 sm12 md12>
                                            <v-flex xs12 sm12 md12 style="padding-right:2px">
                                                <v-card color="#1E88E5" class="white--text">
                                                    <v-layout>
                                                        <v-flex xs2 sm2 md1>
                                                            <v-layout align-center="" justify-center="" fill-height="">
                                                                <v-icon color="white" large="">info</v-icon>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm10 md11>
                                                            <v-card-title primary-title="">
                                                                <v-flex xs12 sm12 md6>
                                                                    <v-layout>
                                                                        <v-flex xs12 sm3 md3>
                                                                            <span class="caption font-weight-bold">
                                                                                Ürün Adı
                                                                            </span>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm9 md6>
                                                                            <span class="caption font-weight-bold">:
                                                                                {{SorunDetay.UrunBilgi.UrunAdi}}
                                                                            </span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md6>
                                                                    <v-layout>
                                                                        <v-flex xs12 sm3 md4>
                                                                            <span class="caption font-weight-bold">
                                                                                Çözecek
                                                                            </span>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm9 md6>
                                                                            <span class="caption font-weight-bold">
                                                                                :{{SorunDetay.CozecekBilgi.AdSoyad}}
                                                                            </span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md6>
                                                                    <v-layout>
                                                                        <v-flex xs12 sm3 md3>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">Alış Tarihi</div>
                                                                            </span>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm9 md3>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">:
                                                                                    {{SorunDetay.AlisTarihi | dateformat}}
                                                                                </div>
                                                                            </span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md6>
                                                                    <v-layout>
                                                                        <v-flex xs12 sm3 md4>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">Arayan</div>
                                                                            </span>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm9 md6>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">:
                                                                                    {{SorunDetay.Arayan}}
                                                                                </div>
                                                                            </span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md6>
                                                                    <v-layout>
                                                                        <v-flex xs12 sm3 md3>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">Süre</div>
                                                                            </span>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm9 md6>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">:
                                                                                    {{minutes}}
                                                                                </div>
                                                                            </span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md6>
                                                                    <v-layout>
                                                                        <v-flex xs12 sm3 md4>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">Sorun Türü</div>
                                                                            </span>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm9 md8>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">:
                                                                                    {{SorunDetay.SorunTip.Aciklama}}
                                                                                </div>
                                                                            </span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md6>
                                                                    <v-layout>
                                                                        <v-flex xs12 sm3 md3>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">Arayan Mail</div>
                                                                            </span>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm9 md5>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">:
                                                                                    {{SorunDetay.ArayanMail}}
                                                                                </div>
                                                                            </span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md6>
                                                                    <v-layout>
                                                                        <v-flex xs12 sm3 md4>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">Sorumlu Birim</div>
                                                                            </span>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm9 md6>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">:
                                                                                    {{SorunDetay.BeklenenYer.Aciklama}}
                                                                                </div>
                                                                            </span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md12>
                                                                    <v-layout>
                                                                        <v-flex xs12 sm3 md2>
                                                                            <span class="caption font-weight-bold">
                                                                                <div class="font-weight-bold caption  white--text  mb-1">Sorun </div>
                                                                            </span>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm9 md5>
                                                                            <span class="caption font-weight-bold white--text" v-html="SorunDetay.SorunAciklama">:
                                                                                <div>
                                                                                </div>
                                                                            </span>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-card-title>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card>
                                            </v-flex>
                                        </v-flex>
                                    </v-layout>
                                    <v-card color="grey lighten-4">
                                        <v-card-text v-if="destekitems == ''">
                                            <v-flex pa-2 xs10 sm12 md2>
                                                <v-layout align-center justify-start row>
                                                    <v-card flat="">
                                                        <v-list-tile>
                                                            <v-list-tile-content style="'overflow=inherit';">
                                                                <v-list-tile-sub-title>
                                                                    <div class="font-weight-bold caption ">
                                                                        Destek Verilmemiştir
                                                                    </div>
                                                                </v-list-tile-sub-title>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </v-card>
                                                </v-layout>
                                            </v-flex>
                                        </v-card-text>
                                        <v-card-text v-if="destekitems != ''">
                                            <v-flex pa-2 xs12 sm12 md12>
                                                <v-list two-line>
                                                    <template v-for="item in destekitems">
                                                        <v-hover v-bind:key="item.SorunID" v-slot:default="{ hover }">
                                                            <v-card :elevation="hover ? 12 : 1">
                                                                <v-layout ma-2 row wrap>
                                                                    <v-flex xs12 sm2 md2>
                                                                        <v-layout align-start="" justify-start fill-height>
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content style="'overflow=inherit';">
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-bold caption ">
                                                                                                Destek No: {{item.DestekID}}
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-bold  caption">
                                                                                                Destek Tip: {{item.DestekTip.Aciklama}}
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm3 md3>
                                                                        <v-layout align-start="" justify-start fill-height>
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content style="'overflow=inherit';">
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-bold  caption">
                                                                                                Çözüm Tipi:{{item.CozumTip.Aciklama}}
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-bold  caption">
                                                                                                Kullanıcı Adı:{{item.UserBilgi.AdSoyad}}
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm3 md3>
                                                                        <v-layout align-start="" justify-start fill-height>
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content style="'overflow=inherit';">
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-bold caption ">
                                                                                                Alış Tarihi: {{item.DestekBaslangicTarih | dateformat}}
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-bold caption ">
                                                                                                Saat Başlangıç: {{item.SaatBaslangic | timeformat}}
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <div class="font-weight-bold caption ">
                                                                                                Saat Bitiş: {{item.SaatBitis | timeformat}}
                                                                                            </div>
                                                                                        </v-list-tile-sub-title>
                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm3 md3>
                                                                        <v-layout align-start="" justify-start fill-height>
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content style="'overflow=inherit';">
                                                                                        <v-list-tile-sub-title>
                                                                                            <v-layout>
                                                                                                <div class="font-weight-bold caption">
                                                                                                    Sorun:
                                                                                                </div>
                                                                                            </v-layout>
                                                                                        </v-list-tile-sub-title>
                                                                                        <v-list-tile-sub-title>
                                                                                            <div v-html="item.DestekAciklama.substring(0,30)" class="font-weight caption "></div>
                                                                                        </v-list-tile-sub-title>
                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>
                                                                    </v-flex>
                                                                    <v-flex xs2 sm1 md1>
                                                                        <v-layout align-end="" justify-center="" fill-height="">
                                                                            <v-card flat="">
                                                                                <v-list-tile>
                                                                                    <v-list-tile-content>
                                                                                        <v-layout>
                                                                                            <v-flex xs12 sm4 md5>
                                                                                                <v-layout>
                                                                                                    <v-btn small icon class="mx-0" @click="DestekDuzenle(item.DestekID)" @click.native="visibledestek=!visibledestek">
                                                                                                        <v-icon color="info">edit</v-icon>
                                                                                                    </v-btn>
                                                                                                </v-layout>
                                                                                            </v-flex>
                                                                                        </v-layout>
                                                                                    </v-list-tile-content>
                                                                                </v-list-tile>
                                                                            </v-card>
                                                                        </v-layout>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-spacer :key="item.id"></v-spacer>
                                                            </v-card>
                                                        </v-hover>
                                                    </template>
                                                </v-list>
                                            </v-flex>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="baslikSorun=='Ekle'" row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-toolbar color="#FFC107" dark>
                                <v-toolbar-title>Sorun {{baslikSorun}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-expansion-panel>
                                <v-expansion-panel-content :value="visible">
                                    <v-card color="grey lighten-4">
                                        <v-card-text>
                                            <v-form ref="formmusteri" lazy-validation>
                                                <v-layout justify-space-between column>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm4 md4>
                                                                    <v-autocomplete :items="itemsUrun" v-model="SorunKayit.UrunBilgi.Ref" item-text="UrunAdi" item-value="Ref" label="Ürün Adı" max-height="400"></v-autocomplete>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <v-autocomplete hide-details="" :items="itemsUserBilgi" item-text="AdSoyad" item-value="UserID" v-model="SorunKayit.CozecekBilgi.UserID" clearable label="Çözecek"></v-autocomplete>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md4>
                                                                    <tarihim :etiket="'Alış Tarihi'" v-model="SorunKayit.AlisTarihi" :detaygizle="false" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm4 md4>
                                                                    <v-autocomplete :items="itemsBekledigiYer" v-model="SorunKayit.BeklenenYer.Id" item-text="Aciklama" item-value="Id" label="İşin Beklediği Yer" max-height="400">
                                                                    </v-autocomplete>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <v-text-field hide-details="" v-model="SorunKayit.Arayan" label="Arayan"></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md4>
                                                                    <v-text-field label="Başlangıç Saati" v-model="SorunKayit.BaslangicSaat" append-outer-icon="access_time">
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm4 md4>
                                                                    <v-autocomplete :items="itemsSorunTip" v-model="SorunKayit.SorunTip.SorunTipID" label="Sorun Türü" item-value="SorunTipID" item-text="Aciklama"></v-autocomplete>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <v-text-field hide-details="" v-model="SorunKayit.ArayanMail" label="Arayan Mail">
                                                                    </v-text-field>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md4>
                                                                    <v-text-field label="Bitiş Saati" v-model="SorunKayit.BitisSaat" append-outer-icon="access_time" required>
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm2 md4>
                                                                    <v-checkbox label="Ücretli Destek" v-model="SorunKayit.UcretliDestek"></v-checkbox>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md4>
                                                                    <v-checkbox label="Çözüldü" v-model="SorunKayit.Cozuldu"></v-checkbox>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md4>
                                                                    <v-text-field v-if=" baslikSorun=='Düzenle' " label="Süre" v-model="minutes" append-outer-icon="access_time"></v-text-field>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout row wrap>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout row wrap>
                                                                <v-flex v-if="baslikSorun=='Ekle'" pa-1 xs12 sm12 md6>
                                                                    <v-layout row wrap>
                                                                        <v-flex pa-1 xs12 sm12 md12>
                                                                            <v-card class="white--text">
                                                                                <v-card color="grey lighten-4" flat="">
                                                                                    <vue-editor placeholder="Sorun Açıklama" v-model="SorunKayit.SorunAciklama"></vue-editor>
                                                                                </v-card>
                                                                            </v-card>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex v-if="baslikSorun=='Ekle'" pa-1 xs12 sm12 md6>
                                                                    <v-layout row wrap>
                                                                        <v-flex pa-1 xs12 sm12 md12>
                                                                            <v-card class="white--text">
                                                                                <v-card color="grey lighten-4" flat="">
                                                                                    <vue-editor placeholder="Ücretli Destek Açıklama" v-model="SorunKayit.UcretliDestkeAciklama"></vue-editor>
                                                                                </v-card>
                                                                            </v-card>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex v-if="baslikSorun=='Düzenle'" pa-1 xs12 sm12 md12>
                                                                    <v-layout row wrap>
                                                                        <v-flex pa-1 xs12 sm12 md12>
                                                                            <v-card class="white--text">
                                                                                <v-card color="grey lighten-4" flat="">
                                                                                    <vue-editor placeholder="Sorun Açıklama" v-model="SorunKayit.SorunAciklama"></vue-editor>
                                                                                </v-card>
                                                                            </v-card>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-divider></v-divider>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout row wrap>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="blue darken-1 white--text" right @click.native="telefonEkle=false">İptal</v-btn>
                                                                <v-btn color="blue darken-1 white--text" v-if="baslikSorun=='Düzenle'" right @click="SorunDuzenleGonder()" @click.native="visible=!visible">Düzenle</v-btn>
                                                                <v-btn color="blue darken-1 white--text" v-if="baslikSorun=='Ekle'" right @click="SorunSave()" @click.native="visible=!visible">Ekle</v-btn>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-layout>
                                            </v-form>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="baslik=='Ekle'" row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-toolbar color="#FFC107" dark>
                                <v-toolbar-title>Destek {{baslik}}</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-expansion-panel>
                                <v-expansion-panel-content :value="visibledestek">
                                    <v-card color="grey lighten-4">
                                        <v-card-text>
                                            <v-flex pa-1 xs12 sm6 md12>
                                                <v-card class="white--text">
                                                    <v-card color="grey lighten-4" flat="">
                                                        <v-card-text>
                                                            <v-layout justify-space-between column>
                                                                <v-flex xs12 sm12 md12>
                                                                    <v-layout row wrap>
                                                                        <v-flex xs12 sm4 md6>
                                                                            <v-autocomplete hide-details="" :items="itemsDestekTip" item-text="Aciklama" item-value="DestekTipID" v-model="DestekEkle.DestekTip.DestekTipID" clearable label="Destek Tipi"></v-autocomplete>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm4 md6>
                                                                            <tarihim :etiket="'Alış Tarihi'" v-model="DestekEkle.DestekBaslangicTarih" :detaygizle="false" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md12>
                                                                    <v-layout row wrap>
                                                                        <v-flex xs12 sm4 md6>
                                                                            <v-autocomplete hide-details="" :items="itemsUserBilgi" item-text="AdSoyad" item-value="UserID" v-model="DestekEkle.UserBilgi.UserID" clearable label="Kullanıcı"></v-autocomplete>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm4 md6>
                                                                            <tarihim :etiket="'Bitiş Tarihi'" v-model="DestekEkle.DestekBitisTarih" :detaygizle="false" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md12>
                                                                    <v-layout row wrap>
                                                                        <v-flex xs12 sm4 md6>
                                                                            <v-autocomplete hide-details="" :items="itemsCozumTip" item-text="Aciklama" item-value="CozumTipID" v-model="DestekEkle.CozumTip.CozumTipID" clearable label="Çözüm Tipi"></v-autocomplete>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm4 md6>
                                                                            <v-text-field label="Başlangıç Saati" v-model="DestekEkle.SaatBaslangic" append-outer-icon="access_time"></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm12 md12>
                                                                    <v-layout row wrap>
                                                                        <v-flex xs12 sm4 md6>
                                                                            <v-text-field hide-details="" label="Fiş No" v-model="DestekEkle.FisNo"></v-text-field>
                                                                        </v-flex>
                                                                        <v-flex xs12 sm4 md6>
                                                                            <v-text-field label="Bitiş Saati" v-model="DestekEkle.SaatBitis" append-outer-icon="access_time"></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-card>
                                            </v-flex>
                                            <v-flex pa-1 xs12 sm6 md12>
                                                <v-layout row wrap>
                                                    <v-flex pa-1 xs12 sm12 md12>
                                                        <v-card class="white--text">
                                                            <v-card color="grey lighten-4" flat="">
                                                                <vue-editor label="Destek" v-model="DestekEkle.DestekAciklama"></vue-editor>
                                                            </v-card>
                                                        </v-card>
                                                    </v-flex>
                                                </v-layout>
                                                <v-divider></v-divider>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout row wrap>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1 white--text" right @click.native="telefonEkle=false">İptal</v-btn>
                                                    <v-btn v-if="baslik == 'Ekle'" color="blue darken-1 white--text" right @click="DestekSave()">Ekle</v-btn>
                                                </v-layout>
                                            </v-flex>
                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
    <v-dialog v-model="telefonEkle" scrollable persistent="" max-width="600px">
        <v-card color="grey lighten-2">
            <v-toolbar dark color="info">
                <v-toolbar-title>Telefon Bekliyor Ekle</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row="" wrap="">
                    <v-flex xs12 sm4 md12>
                        <v-text-field v-model="SorunEkle.Arayan" label="Arayan">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <v-autocomplete v-model="SorunEkle.CozecekBilgi.UserID" label="Kullanıcı" item-text="KullaniciAd" item-value="Ref" hide-details="" :items="userlist" clearable="" color="grey darken-1">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <vue-editor v-model="SorunEkle.SorunAciklama" placeholder="Açıklama"></vue-editor>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="telefonEkle=false">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click="telefonGiris()">Ekle</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="destekGuncelle" scrollable persistent="" max-width="600px">
        <v-card color="grey lighten-4">
            <v-toolbar dark color="info">
                <v-toolbar-title>Destek Güncelle</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card>
                <v-card-text>
                    <v-flex pa-1 xs12 sm6 md12>
                        <v-card class="white--text">
                            <v-card color="grey lighten-4" flat="">
                                <v-card-text>
                                    <v-layout justify-space-between column>
                                        <v-flex xs12 sm12 md12>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm4 md6>
                                                    <v-autocomplete hide-details="" :items="itemsDestekTip" item-text="Aciklama" item-value="DestekTipID" v-model="DestekEkle.DestekTip.DestekTipID" clearable label="Destek Tipi"></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm4 md6>
                                                    <tarihim :etiket="'Alış Tarihi'" v-model="DestekEkle.DestekBaslangicTarih" :detaygizle="false" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm4 md6>
                                                    <v-autocomplete hide-details="" :items="itemsUserBilgi" item-text="AdSoyad" item-value="UserID" v-model="DestekEkle.UserBilgi.UserID" clearable label="Kullanıcı"></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm4 md6>
                                                    <tarihim :etiket="'Bitiş Tarihi'" v-model="DestekEkle.DestekBitisTarih" :detaygizle="false" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm4 md6>
                                                    <v-autocomplete hide-details="" :items="itemsCozumTip" item-text="Aciklama" item-value="CozumTipID" v-model="DestekEkle.CozumTip.CozumTipID" clearable label="Çözüm Tipi"></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm4 md6>
                                                    <v-text-field label="Başlangıç Saati" v-model="DestekEkle.SaatBaslangic" append-outer-icon="access_time"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12 sm12 md12>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm4 md6>
                                                    <v-text-field hide-details="" label="Fiş No" v-model="DestekEkle.FisNo"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm4 md6>
                                                    <v-text-field label="Bitiş Saati" v-model="DestekEkle.SaatBitis" append-outer-icon="access_time"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-card>
                    </v-flex>
                    <v-flex pa-1 xs12 sm6 md12>
                        <v-layout row wrap>
                            <v-flex pa-1 xs12 sm12 md12>
                                <v-card class="white--text">
                                    <v-card color="grey lighten-4" flat="">
                                        <vue-editor label="Destek" v-model="DestekEkle.DestekAciklama"></vue-editor>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                    </v-flex>
                </v-card-text>
            </v-card>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="destekGuncelle=false">İptal</v-btn>
                <v-btn v-if="baslik == 'Güncelle'" color="blue darken-1 white--text" flat right @click="DestekUpdate()">Güncelle</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="sorunGuncelle" scrollable persistent="" max-width="600px">
        <v-card color="grey lighten-2">
            <v-toolbar dark color="info">
                <v-toolbar-title>Sorun Güncelle</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-form ref="formmusteri" lazy-validation>
                    <v-layout justify-space-between column>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 md4>
                                        <v-autocomplete :items="itemsUrun" v-model="SorunKayit.UrunBilgi.Ref" item-text="UrunAdi" item-value="Ref" label="Ürün Adı" max-height="400"></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <v-autocomplete hide-details="" :items="itemsUserBilgi" item-text="AdSoyad" item-value="UserID" v-model="SorunKayit.CozecekBilgi.UserID" clearable label="Çözecek"></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm2 md4>
                                        <tarihim :etiket="'Alış Tarihi'" v-model="SorunKayit.AlisTarihi" :detaygizle="false" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 md4>
                                        <v-autocomplete :items="itemsBekledigiYer" v-model="SorunKayit.BeklenenYer.Id" item-text="Aciklama" item-value="Id" label="İşin Beklediği Yer" max-height="400">
                                        </v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <v-text-field hide-details="" v-model="SorunKayit.Arayan" label="Arayan"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm2 md4>
                                        <v-text-field label="Başlangıç Saati" v-model="SorunKayit.BaslangicSaat" append-outer-icon="access_time">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 md4>
                                        <v-autocomplete :items="itemsSorunTip" v-model="SorunKayit.SorunTip.SorunTipID" label="Sorun Türü" item-value="SorunTipID" item-text="Aciklama"></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <v-text-field hide-details="" v-model="SorunKayit.ArayanMail" label="Arayan Mail">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm2 md4>
                                        <v-text-field label="Bitiş Saati" v-model="SorunKayit.BitisSaat" append-outer-icon="access_time" required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm2 md4>
                                        <v-checkbox label="Ücretli Destek" v-model="SorunKayit.UcretliDestek"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 sm2 md4>
                                        <v-checkbox label="Çözüldü" v-model="SorunKayit.Cozuldu"></v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 sm2 md4>
                                        <v-text-field v-if=" baslikSorun=='Düzenle' " label="Süre" v-model="minutes" append-outer-icon="access_time"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex v-if="baslikSorun=='Düzenle'" pa-1 xs12 sm12 md12>
                                        <v-layout row wrap>
                                            <v-flex pa-1 xs12 sm12 md12>
                                                <vue-editor placeholder="Sorun Açıklama" v-model="SorunKayit.SorunAciklama"></vue-editor>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="sorunGuncelle=false">İptal</v-btn>
                <v-btn color="blue darken-1 white--text" right @click="SorunDuzenleGonder()" @click.native="visible=!visible">Güncelle</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="600px">
        <v-card color="grey lighten-2">
            <v-toolbar dark color="info">
                <v-toolbar-title>Filtre Seçimi</v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row="" wrap="">

                    <v-flex xs12 sm4 md12>
                        <tarihim :etiket="'Alış Tarihi'" v-model="Destek.BaslangicTarih" :detaygizle="false" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <tarihim :etiket="'Bitiş Tarihi'" v-model="Destek.BitisTarih" :detaygizle="false" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                    </v-flex>

                    <v-flex xs12 sm4 md12>
                        <v-select hide-details="" v-model="hizmet" :items="itemshizmet" color="grey darken-1" item-text="text" item-value="value" label="Hizmet Türü"></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <v-select hide-details="" v-model="durum" :items="itemsdurum" color="grey darken-1" item-text="text" item-value="value" label="Durum"></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <v-select hide-details="" v-model="kisit" :items="itemskisit" color="grey darken-1" item-text="text" item-value="value" label="Kısıt"></v-select>
                    </v-flex>
                    <v-flex xs12 sm4 md12>
                        <v-select hide-details="" clearable="" :items="itemsUserBilgi" item-text="AdSoyad" item-value="UserID" color="grey darken-1" v-model="Destek.Cozecek" label="Kullanıcı Adı">
                        </v-select>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogfiltre=false">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click="sorunListelefiltre()">Filtrelerİ Uygula</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
    </v-snackbar>
</div>
</template>

<script>
import auth from '../../../api/auth'
import tarihim from '../customcomp/tarihim'
import helpers from "@/components/app/customcomp/helpers.js"
import axios from 'axios'
import tool from "@/components/app/coper/tools"

import {
    VueEditor
} from "vue2-editor"
export default {
    data() {
        return {
            bgColor: "#4275f5",
            secilen: false,
            destekGuncelle: false,
            sorunGuncelle: false,
            dialogfiltre: false,
            visible: false,
            visibledestek: false,
            visiblelist: false,
            telefonEkle: false,
            visibledestekliste: false,
            visibleSorunDetay: false,
            sorunitems: [],
            bekleyenitems: [],
            telefonitems: [],
            userlist: [],
            musteriitems: [],
            itemsUserBilgi: [],
            itemsUrun: [],
            itemsBekledigiYer: [],
            itemsSorunTip: [],
            itemsDestekTip: [],
            itemsCozumTip: [],
            destekitems: [],
            saatHesaplaList: [],
            minutes: '',
            KullaniciAdi: '',
            DestekSaveID: '',
            baslik: '',
            baslikSorun: '',
            baslikDestek: '',
            load2: false,
            vmodelpagination: false,
            sayfalama: 1,
            pagenumber: 1,
            SayfaNo: 1,
            VeriAdet: 20,
            files: [],
            valid: true,
            text1: '',
            snackbar: false,
            loading: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 2000,
            hizmet: null,
            durum: null,
            kisit: null,
            loading: false,
            deneme: 25899999,
            itemshizmet: [{
                    text: 'Hepsi',
                },
                {
                    text: 'Sözleşmeli',
                    value: '0'
                }, {
                    text: 'Ücretli',
                    value: '1'
                },
            ],
            itemskisit: [{
                    text: 'Hepsi',
                },
                {
                    text: 'Firmaya Göre',
                    value: '0'
                },
                {
                    text: 'Kullanıcıya Göre',
                    value: '1'
                },
            ],
            itemsdurum: [{
                    text: 'Hepsi',
                },
                {
                    text: 'Çözülmedi',
                    value: '0'
                }, {
                    text: 'Çözüldü',
                    value: '1'
                },
            ],
            Destek: {
                MusteriID: null,
                UserID: null,
                BaslangicTarih: null,
                BitisTarih: null,
                Cozuldu: null,
                UcretliDestek: null,
                Paging: {
                    SayfaNo: 1,
                    VeriAdet: 20,
                }
            },
            SorunKayit: {
                SorunID: null,
                MusteriBilgi: {
                    MusteriID: null,
                    MusteriKod: null,
                    MusteriAdi: null,
                },
                UserBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                AlisTarihi: null,
                Arayan: null,
                ArayanMail: null,
                CozecekBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                Cozuldu: null,
                UrunBilgi: {
                    Ref: null,
                    UrunAdi: null,
                    UrunAciklama: null,
                    Aciklama: null,
                },
                SorunAciklama: null,
                SorunTip: {
                    SorunTipID: null,
                    Aciklama: null,
                },
                BaslangicSaat: null,
                BitisSaat: null,
                BeklenenYer: {
                    Id: null,
                    ParentId: null,
                    Aciklama: null,
                    Yetki: null,
                },
                UcretliDestek: null,
                UcretliDestekAciklama: null,
            },
            SorunEkle: {
                SorunID: null,
                MusteriBilgi: {
                    MusteriID: 665,
                    MusteriKod: null,
                    MusteriAdi: null,
                },
                UserBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                AlisTarihi: null,
                Arayan: null,
                ArayanMail: null,
                CozecekBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                Cozuldu: 0,
                UrunBilgi: {
                    Ref: null,
                    UrunAdi: null,
                    UrunAciklama: null,
                    Aciklama: null,
                },
                SorunAciklama: null,
                SorunTip: {
                    SorunTipID: 6,
                    Aciklama: null,
                },
                BaslangicSaat: null,
                BitisSaat: null,
                BeklenenYer: {
                    Id: null,
                    ParentId: null,
                    Aciklama: null,
                    Yetki: null,
                },
                UcretliDestek: null,
                UcretliDestekAciklama: null,
            },
            SorunDetay: {
                SorunID: null,
                MusteriBilgi: {
                    MusteriID: null,
                    MusteriKod: null,
                    MusteriAdi: null,
                },
                UserBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                AlisTarihi: null,
                Arayan: null,
                ArayanMail: null,
                CozecekBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                Cozuldu: null,
                UrunBilgi: {
                    Ref: null,
                    UrunAdi: null,
                    UrunAciklama: null,
                    Aciklama: null,
                },
                SorunAciklama: null,
                SorunTip: {
                    SorunTipID: null,
                    Aciklama: null,
                },
                BaslangicSaat: null,
                BitisSaat: null,
                BeklenenYer: {
                    Id: null,
                    ParentId: null,
                    Aciklama: null,
                    Yetki: null,
                },
                UcretliDestek: null,
                UcretliDestekAciklama: null,
            },
            DestekEkle: {
                DestekID: null,
                SorunID: null,
                DestekTip: {
                    DestekTipID: null,
                    Aciklama: null,
                },
                UserBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                DestekBaslangicTarih: null,
                DestekBitisTarih: null,
                DestekAciklama: null,
                FisNo: null,
                CozumTip: {
                    CozumTipID: null,
                    Aciklama: null,
                },
                SaatBaslangic: null,
                SaatBitis: null,
            },
            sorunVeri: {
                MusteriKod: null,
                Cozecek: null,
            },
        }
    },
    beforeMount: beforeMount,
    methods: {

        handleFilesUpload() {
            this.files = []
            let uploadedFiles = this.$refs.files.files;
            if (uploadedFiles.length > 0) {
                this.alertcolor = "success";
                this.alertmessage = "Toplam " + uploadedFiles.length + " adet dosya seçildi."
                this.load2 = true;
                for (var i = 0; i < uploadedFiles.length; i++) {
                    this.files.push(uploadedFiles[i]);
                }
            } else {
                this.alertmessage = "Henüz Dosya Seçilmedi...";
                this.alertcolor = "red";
                this.load2 = false;
            }
        },
        btnSubmitFiles() {
            let formData = new FormData();
            for (var i = 0; i < this.files.length; i++) {
                let file = this.files[i];
                formData.append('file[' + i + ']', file);
            }
            formData.append('SorunID', this.DestekSaveID)
            axios.defaults.baseURL = auth.API_URL;
            //axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
            axios.post(auth.API_URL + 'api/Calendar/FileUploadSupport',
                    formData, {
                        headers: {
                            Authorization: `Bearer ${auth.getAuthHeader()}`
                        }
                    }
                ).then((response) => {
                    if (response.data == true) {
                        this.text1 = 'Dosya Yükleme Başarılı'
                        this.snackbar = true
                        this.progress = false
                    } else {
                        this.text1 = "Dosya Yükleme Başarısız"
                        this.snackbar = true
                    }
                })
                .catch(function () {
                    console.log('hata!!');
                });

        },
        addFiles() {
            this.$refs.files.click();
        },
        load1() {
            return (this.files.length <= 0);
        },
        sorunListele: sorunListele,
        sorunListelefiltre: sorunListelefiltre,
        BekleyenSorunlar: BekleyenSorunlar,
        BekleyenSorunlarSayi: BekleyenSorunlarSayi,
        telefonBekliyorCek: telefonBekliyorCek,
        telefonBekliyorCekSayi: telefonBekliyorCekSayi,
        telefonGiris: telefonGiris,
        userCek: userCek,
        telefonAc: telefonAc,
        musteriCek: musteriCek,
        userBilgileri: userBilgileri,
        musteriBilgi: musteriBilgi,
        urunBilgi: urunBilgi,
        isinBekledigiYerBilgi: isinBekledigiYerBilgi,
        sorunTuruBilgi: sorunTuruBilgi,
        SorunSave: SorunSave,
        saatCanli: saatCanli,
        SaatBaslangic: SaatBaslangic,
        zeroPadding: zeroPadding,
        saatHesapla: saatHesapla,
        SorunSaveAfter: SorunSaveAfter,
        DestekSave: DestekSave,
        DestekIDSave: DestekIDSave,
        destekTipCek: destekTipCek,
        cozumTipCek: cozumTipCek,
        DestekListele: DestekListele,
        SorunDuzenle: SorunDuzenle,
        SorunDuzenleGonder: SorunDuzenleGonder,
        DestekDuzenle: DestekDuzenle,
        DestekUpdate: DestekUpdate,
        MusteriYenile: MusteriYenile,
        filtrele: filtrele,
    },
    computed: {
        Styles() {
            return {
                "background-color": this.bgColor,
            };
        },
    },
    components: {
        tarihim,
        VueEditor
    },
    watch: {
        'kayitadet': function (valueveriadet) {
            this.getList(1, valueveriadet, this.siralamatipi, false)
        },
        'siralamatipi': function (tip) {
            this.sayfalama = 1;
            this.getList(1, this.kayitadet, tip, false)
        },
        'sayfalama': function (sayfa) {
            this.getList(sayfa, this.kayitadet, this.siralamatipi, false)
        }
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        timeformat: function (c) {
            return helpers.timeformat(c);
        },
    }
}

function beforeMount() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    this.KullaniciAdi = response.AdSoyad
    this.Destek.BaslangicTarih = helpers.getDateNow()
    this.Destek.BitisTarih = helpers.getDateNow()
    this.sorunListele()
  //  this.BekleyenSorunlarSayi()
   // this.telefonBekliyorCekSayi()
    this.musteriCek()
   // this.SaatBaslangic()
   // this.saatCanli()
}

function musteriBilgi() {

    this.baslikDestek = '22',
        this.baslik = '22'
    if (this.SorunKayit.MusteriBilgi.MusteriID == null) {
        this.text1 = 'Lütfen Müşteri Seçin'
        this.snackbar = true
        musteriBilgi().stop()
    }
    this.baslikSorun = 'Ekle'
    this.userBilgileri()
    this.urunBilgi()
    this.isinBekledigiYerBilgi()
    this.sorunTuruBilgi()
}

function filtrele() {
    this.dialogfiltre = true
}

function MusteriYenile(val, secilenSorun) {
    var params1 = {
        VeriAdet: 50,
        SayfaNo: 1,
        UserID: 0,
        BaslangicTarih: '1980-01-01',
        BitisTarih: this.Destek.BitisTarih,
        Cozuldu: null,
        UcretliDestek: 0,
        MusteriID: val,

    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params1, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        this.sorunitems = response.body
        this.progress = false
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        } else {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        }
    })
}

function DestekUpdate() {
    this.baslik = 'asd'
    this.baslikDestek = 'Sorun Detay'
    var params = this.DestekEkle
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportSave', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.destekGuncelle = false
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true

        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
    this.sorunListele()
}

function DestekDuzenle(val) {
    this.baslik = 'Güncelle'
    this.destekGuncelle = true

    var params = {
        SupportID: val
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportLoad', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.DestekEkle = response.body
        this.DestekEkle.SaatBaslangic = this.DestekEkle.SaatBaslangic.substring(11, 19)

    }, (response) => {
        if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
    this.cozumTipCek()
    this.destekTipCek()
    this.userBilgileri()
}

function SorunDuzenleGonder() {
    this.baslikDestek = 'Sorun Detay',
        this.baslik = '22'
    this.baslikSorun = '22'
    var params = this.SorunKayit
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsSave', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.telefonEkle = false
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
    this.sorunListele()
}

function SorunDuzenle(val, valSirket) {
    this.deneme = val
    this.sorunGuncelle = true
    this.baslikSorun = 'Düzenle'
    this.SorunKayit.MusteriBilgi.MusteriID = valSirket
    var params = {
        ProblemID: val
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsLoad', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.SorunKayit = response.body
        this.saatHesaplaList = response.body
        var date1 = new Date(this.saatHesaplaList.BaslangicSaat)
        var date2 = new Date(this.saatHesaplaList.BitisSaat)
        var res = Math.abs(date1 - date2) / 1000
        var hours = Math.floor(res / 3600) % 24;
        var last = Math.floor(res / 60) % 60
        var seconds = res % 60;
        if (last < 9) {
            this.minutes = '0' + hours + ' : ' + '0' + last + ' : ' + seconds
        } else {
            this.minutes = '0' + hours + ' : ' + last + ' : ' + seconds
        }
        this.SorunKayit.BaslangicSaat = this.SorunKayit.BaslangicSaat.substring(11, 19)
        this.SorunKayit.BitisSaat = this.SorunKayit.BitisSaat.substring(11, 19)
    }, (response) => {
        if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
    this.MusteriYenile(valSirket)
    this.userBilgileri()
    this.urunBilgi()
    this.isinBekledigiYerBilgi()
    this.sorunTuruBilgi()
}

function DestekListele(val, valSirket) {
    this.deneme = val
    this.DestekSaveID = val
    this.visibledestekliste = false
    this.visibledestek = false
    this.baslik = '22'
    this.baslikDestek = 'Sorun Detay'

    this.SorunKayit.MusteriBilgi.MusteriID = valSirket
    var params = {
        ProblemID: val
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsLoad', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.SorunDetay = response.body
        this.saatHesaplaList = response.body
        var date1 = new Date(this.saatHesaplaList.BaslangicSaat)
        var date2 = new Date(this.saatHesaplaList.BitisSaat)

        var res = Math.abs(date1 - date2) / 1000
        var hours = Math.floor(res / 3600) % 24;
        var last = Math.floor(res / 60) % 60
        var seconds = res % 60;

        if (last < 9) {
            this.minutes = '0' + hours + ' : ' + '0' + last + ' : ' + seconds
        } else {
            this.minutes = '0' + hours + ' : ' + last + ' : ' + seconds
        }
    }, (response) => {
        if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
    this.MusteriYenile(valSirket)

    var userparams = {
        SorunID: val,
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportList', userparams, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        this.destekitems = response.body
        this.progress = false
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        } else {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        }
    })
}

function destekTipCek() {
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportTypeList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsDestekTip = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function cozumTipCek() {
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SolutionTypeList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsCozumTip = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function DestekSave() {
    this.baslik = 'asd'
    this.baslikDestek = 'Sorun Detay'

    this.DestekEkle.SorunID = this.DestekSaveID
    var params = this.DestekEkle
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportSave', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true

        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
    this.sorunListele()
}

function DestekIDSave(val, valSirket) {
    this.deneme = val
    this.SorunKayit.MusteriBilgi.MusteriID = valSirket
    this.baslik = 'Ekle'
    this.baslikDestek = '22'
    this.visibledestek = false
    this.baslikSorun = '22'
    this.DestekSaveID = val
    this.cozumTipCek()
    this.destekTipCek()
    this.userBilgileri()
    this.MusteriYenile(valSirket)
}

function SorunSaveAfter() {

}

function saatCanli() {
    setInterval(() => {
        var cd = new Date();
        this.SorunKayit.BitisSaat = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
        this.DestekEkle.SaatBitis = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
    }, 1000);
}

function SaatBaslangic() {
    var sb = new Date();
    this.SorunKayit.BaslangicSaat = zeroPadding(sb.getHours(), 2) + ':' + zeroPadding(sb.getMinutes(), 2) + ':' + zeroPadding(sb.getSeconds(), 2);
    this.DestekEkle.SaatBaslangic = zeroPadding(sb.getHours(), 2) + ':' + zeroPadding(sb.getMinutes(), 2) + ':' + zeroPadding(sb.getSeconds(), 2);

}

function zeroPadding(num, digit) {
    var zero = '';
    for (var i = 0; i < digit; i++) {
        zero += '0';
    }
    return (zero + num).slice(-digit);
}

function saatHesapla() {
    var params = {
        ProblemID: this.$route.query.sorunid
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsLoad', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.saatHesaplaList = response.body
        var date1 = new Date(this.saatHesaplaList.BaslangicSaat)
        var date2 = new Date(this.saatHesaplaList.BitisSaat)
        var res = Math.abs(date1 - date2) / 1000
        var hours = Math.floor(res / 3600) % 24;
        var last = Math.floor(res / 60) % 60
        var seconds = res % 60;
        if (last < 9) {
            this.minute = '0' + hours + ' : ' + '0' + last + ' : ' + seconds
        } else {
            this.minute = '0' + hours + ' : ' + last + ' : ' + seconds
        }
    }, (response) => {
        if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function SorunSave() {
    this.baslikSorun = 'asda'

    var params = this.SorunKayit
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsSave', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.telefonEkle = false
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
    this.sorunListele()
}

function sorunTuruBilgi() {
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemTypeList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsSorunTip = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function isinBekledigiYerBilgi() {
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ExpectedList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsBekledigiYer = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function urunBilgi() {
    this.$http.post(auth.API_URL + 'api/Awed/AwedProductList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsUrun = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function userBilgileri() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    var params = {

        Email: response.Email
    }
    this.$http.post(auth.API_URL + 'api/Register/WebUserList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsUserBilgi = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function musteriCek() {
    this.$http.post(auth.API_URL + 'api/Awed/CustomerAllList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        this.musteriitems = response.body
        this.progress = false
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        } else {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        }
    })
}

function telefonAc() {
    this.telefonEkle = true
    this.userCek()
}

function telefonGiris() {

    var params = this.SorunEkle
    this.SorunEkle.AlisTarihi = this.Destek.BitisTarih,
        this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsSave', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
            this.telefonEkle = false
        }, (response) => {
            if (response.Status === true) {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
            } else {
                this.text1 = response.statusText
                this.snackbar = true
            }
        })

}

function userCek() {
    this.$http.post(auth.API_URL + 'api/Calendar/UserList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        this.userlist = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-'
            this.snackbar = true
        }
    })
}

function BekleyenSorunlar() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    var params = {
        BaslangicTarih: '1980-01-01',
        BitisTarih: this.Destek.BitisTarih,
        Cozuldu: 0,
        UserID: response.UserId
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {}).then((response) => {
        this.sorunitems = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })
}

function BekleyenSorunlarSayi() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    var params = {
        BaslangicTarih: '1980-01-01',
        BitisTarih: this.Destek.BitisTarih,
        Cozuldu: 0,
        UserID: response.UserId
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {}).then((response) => {
        this.bekleyenitems = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })
}

function sorunListelefiltre() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    if (this.hizmet == 0) {
        this.Destek.UcretliDestek = 0
    }
    if (this.hizmet == 1) {
        this.Destek.UcretliDestek = 1
    }
    if (this.durum == 0) {
        this.Destek.Cozuldu = 0
    }
    if (this.durum == 1) {
        this.Destek.Cozuldu = 1
    }
    if (this.kisit == 0) {
        this.Destek.MusteriID = 99999
    }
    if (this.kisit == 1) {
        this.Destek.UserID = response.UserId
    }
    var params = {
        MusteriID: this.Destek.MusteriID,
        UcretliDestek: this.Destek.UcretliDestek,
        Cozuldu: this.Destek.Cozuldu,
        UserID: this.Destek.UserID,
        VeriAdet: 50,
        SayfaNo: 1,
        BaslangicTarih: '1980-01-01',
        BitisTarih: this.Destek.BitisTarih,
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {}).then((response) => {
        this.sorunitems = response.body
        this.pagenumber = response.body.TotalPage;
        this.vmodelpagination = true;
        this.dialogfiltre = false
        this.load1 = true
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })
}

function sorunListele() {
    var params = {
        VeriAdet: 50,
        SayfaNo: 1,
        BaslangicTarih: '1980-01-01',
        BitisTarih: this.Destek.BitisTarih,
    }

    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {}).then((response) => {
        this.sorunitems = response.body
        this.pagenumber = response.body.TotalPage;
        this.vmodelpagination = true;
        this.load1 = true
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })
}

function telefonBekliyorCek() {
    var params = {
        MusteriID: 665,
        Cozuldu: 0,
        BaslangicTarih: '1980-01-01',
        BitisTarih: this.Destek.BitisTarih,
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {

    }).then((response) => {
        this.sorunitems = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })
    this.dialogfiltre = false
}

function telefonBekliyorCekSayi() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    var params = {
        MusteriID: 665,
        Cozuldu: 0,
        BaslangicTarih: '1980-01-01',
        BitisTarih: this.Destek.BitisTarih,
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {

    }).then((response) => {
        this.telefonitems = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
        }
    })
    this.dialogfiltre = false
}
</script>
